import DashboardCard, { DashboardCardProps } from './DashboardCard';

export type { DashboardCardProps };
export default DashboardCard;
